import { ApolloLink } from '@apollo/client';

var HeaderName = 'X-Deal-New-Auth-Sent';
function reconnectAuthChange(reconnect) {
    return new ApolloLink(function (operation, forward) {
        var observable = forward(operation);
        if (!observable.map) {
            return observable;
        }
        return observable.map(function (executionResult) {
            var response = operation.getContext().response;
            if (response && response.headers && response.headers.get(HeaderName) === 'true') {
                reconnect();
            }
            return executionResult;
        });
    });
}

export default reconnectAuthChange;
//# sourceMappingURL=reconnectAuthChange.js.map
